<template>
  <div class="footer">
    <ul class="footer-menu_ul">
      <li class="footer-menu_li">
        <a
          class="footer-menu_a"
          href="https://mira-now.site/privacy-policy/"
          target="_blank"
        >プライバシーポリシー</a>
      </li>
      <li class="footer-menu_li">
        <a class="footer-menu_a" href="https://mira-now.site/tokutei/" target="_blank">特定商取引法に基づく表記</a>
      </li>
    </ul>
    <div class="footer-credit">
      <p class="footer-credit_text">©2020 by KINDLER, Inc.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>

<style scoped>
.footer {
  width: 100%;
  padding: 48px 16px;
  background-color: #140a1e;
}
.footer-menus {
  width: 100%;
}
.footer-menu_ul {
  text-align: center;
}
.footer-menu_li {
  display: inline-block;
}
.footer-menu_a {
  font-size: 12px;
  color: #ffffff;
  padding: 0px 16px;
}
.footer-credit {
  width: 100%;
  margin-top: 12px;
}
.footer-credit_text {
  font-size: 12px;
  text-align: center;
  color: #8f8c99;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue